import { BaseModel, Guid, RecursivePartial } from '@models/base';

export class TaskLinkTask extends BaseModel {
    id?: Guid;
    shortId?: string;
    projectId?: Guid;
    subj?: string;
    priority?: number;
    assignee?: Guid;
    assigneeGroup?: Guid;
    createdBy?: Guid;

    constructor(json?: RecursivePartial<TaskLinkTask>) {
        super(json);
        this.parseTaskLinkTask(json || {});
    }

    parse(json: RecursivePartial<TaskLinkTask>): TaskLinkTask {
        super.parse(json);
        this.parseTaskLinkTask(json);
        return this;
    }

    private parseTaskLinkTask(json: RecursivePartial<TaskLinkTask>): void {
        TaskLinkTask.assignFields<TaskLinkTask>(this, json, [
            'id',
            'shortId',
            'projectId',
            'subj',
            'priority',
            'assignee',
            'assigneeGroup',
            'createdBy',
        ]);
    }

}
